import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon--h",
  "use": "icon-icon--h-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon--h\"><path fill=\"currentColor\" d=\"M928 288H96v384h160v224h512V672h160zM704 832H320V544h384z m160-224h-96v-128H256v128h-96V352h704zM320 192h384v64h64V128H256v128h64v-64z\" /><path fill=\"currentColor\" d=\"M384 608h256v64H384zM384 704h256v64H384z\" /><path fill=\"currentColor\" d=\"M800 416m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon--h.svg
// module id = lF4R
// module chunks = 101